/**
 * Procedure Categories and Procedures for MS / Diploma in Ophthalmology (MS Ophthalmology) students
 * Extracted with strict evidence from official NMC PDF (Page 5-9: "Essential diagnostic skills" & "Surgical procedures")
 */
export const OPHTHALMOLOGY_PROCEDURES = {
  "Diagnostic & Refraction Procedures": [
    "Tonometry (Applanation / Indentation / Non-Contact)",
    "Gonioscopy & Anterior Chamber Angle Grading",
    "Lacrimal Function Tests (Schirmer Test, Lacrimal Syringing & Dacryocystography)",
    "Corneal Scraping, Cauterization, Keratometry & Pachymetry",
    "Refraction (Streak Retinoscopy, Subjective & Objective Refraction & Glasses Prescription)",
  ],
  "Ocular Anaesthesia & Minor Ophthalmic Procedures": [
    "Retrobulbar & Peribulbar Anaesthesia",
    "Facial Nerve Blocks (O'Brien / Atkinson / Van Lint) & Orbital Nerve Blocks",
    "Slit Lamp Foreign Body Removal (Conjunctival & Corneal)",
    "Chalazion Incision and Curettage",
    "Subconjunctival & Posterior Sub-Tenon's Injections",
    "Corneal & Corneoscleral Suture Removal",
    "Fitting of Artificial Eye & Ocular Prosthesis",
  ],
  "Ophthalmic Surgical & Microscopic Procedures": [
    "Cataract Surgery (ECCE / SICS / Phacoemulsification with IOL Implantation)",
    "Secondary Intraocular Lens (IOL) Implantation (AC / PC IOL)",
    "Pterygium Excision & Ocular Surface Flap / Peritomy Procedures",
    "Lid Surgeries (Tarsorrhaphy, Entropion / Ectropion Repair, Lid Trauma Repair, Epilation)",
    "Sac Surgeries (Dacryocystectomy / DCT, Dacryocystorhinostomy / DCR & Nasolacrimal Probing)",
    "Destructive Ocular Surgeries (Evisceration & Enucleation with/without Implant)",
    "Glaucoma Surgery (Trabeculectomy & Cyclocryotherapy / Cyclophotocoagulation)",
    "Strabismus Surgery (Recession & Resection on Horizontal Recti)",
    "Repair of Corneo-Scleral Perforations & Tissue Glue Application",
    "Intra-Vitreal & Intra-Cameral Injections",
    "Ophthalmic Laser Procedures (YAG Capsulotomy, Laser Iridotomy & Photocoagulation)",
  ],
};

export const OPHTHALMOLOGY_CATEGORIES = Object.keys(OPHTHALMOLOGY_PROCEDURES);

export const isDiplomaInOphthalmologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("ophthalmology") ||
    d.includes("eye") ||
    d.includes("opthalmology")
  );
};

export const isMSInOphthalmologyDept = isDiplomaInOphthalmologyDept;
